import styled from "styled-components";

export const AvatarBody = styled.img<{size: string | number}> `
  object-fit: cover;
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  border-radius: 100%;
`;